import React from 'react';
import PropTypes from 'prop-types';

import {connect} from 'react-redux';
import {withRouter} from 'react-router';

import Breadcrumbs from '../../components/breadcrumbs/Breadcrumbs';


@withRouter
@connect(({ui}) => ({
  breadcrumbs: ui.breadcrumbs
}))
export default class BreadcrumbsContainer extends React.PureComponent {
  render() {
    const {location, breadcrumbs, append, only} = this.props;

    let links = breadcrumbs.map(({name, slug}) => ({name, slug: location.pathname === `/${slug}` ? false : `/${slug}`}));

    if (!links.length) {
      links = [{name: 'Home', slug: '/'}];
    }

    if (only) {
      links = [links[0]];
    }

    if (append) {
      links = links.concat(append);
    }

    return (
      <Breadcrumbs links={links}/>
    );
  }
}



// WEBPACK FOOTER //
// ./containers/breadcrumbsContainer/BreadcrumbsContainer.js